// extracted by mini-css-extract-plugin
module.exports = {"title":"TaskComponent_title__1HWUr","line":"TaskComponent_line__2ddPg","desc":"TaskComponent_desc__2804D"};